import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  statsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: '0 1rem',

    [theme.breakpoints.down('lg')]: {
      borderRadius: '0',
      height: 'auto',
      maxHeight: '450px',
      border: 'none'
    }
  },

  emptyTitle: {
    textAlign: 'center',
    color: 'rgb(127, 132, 135)',
    opacity: '0.7',
    fontSize: theme.size.sm
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    fontSize: theme.size.base,
    textAlign: 'center',

    [theme.breakpoints.down('lg')]: {
      marginBottom: '0',
      paddingLeft: '0'
    }
  },

  statusInfo: {
    fontSize: theme.size.sm,
    display: 'flex',
    alignItems: 'center',

    '&:not(:last-child)': {
      marginBottom: '0.75rem'
    },

    [theme.breakpoints.down('lg')]: {
      marginLeft: '1rem',
      alignItems: 'center'
    }
  },

  dot: {
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: '11px',
    height: '11px'
  },

  chartContainer: {
    position: 'relative',
    minWidth: '207px',
    height: '100%'
  },

  pieChart: {
    position: 'absolute'
  }
}))

export default useStyles
